import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrowning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 46,
	height: 46,
	viewBox: "0 0 46 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599976 23 0.599976C10.6288 0.599976 0.599976 10.6288 0.599976 23C0.599976 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint0_radial_5_4677)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599976 23 0.599976C10.6288 0.599976 0.599976 10.6288 0.599976 23C0.599976 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint1_radial_5_4677)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1781 15.118C19.4161 14.25 18.6181 13.452 17.0081 13.018C15.6361 12.654 12.4301 12.598 9.6441 14.712C9.1261 15.104 9.64409 15.524 10.1061 15.314C11.6741 14.572 15.4541 14.096 18.0441 15.104C19.0801 15.51 19.1781 15.118 19.1781 15.118Z",
			fill: "url(#paint2_linear_5_4677)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6781 24.2041C16.8688 24.2041 17.8341 22.7437 17.8341 20.9421C17.8341 19.1406 16.8688 17.6801 15.6781 17.6801C14.4874 17.6801 13.5221 19.1406 13.5221 20.9421C13.5221 22.7437 14.4874 24.2041 15.6781 24.2041Z",
			fill: "url(#paint3_radial_5_4677)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6781 18.7718C16.6021 18.7718 17.4141 19.5838 17.8341 20.7738C17.8061 19.0098 16.8541 17.5958 15.6781 17.5958C14.5021 17.5958 13.5501 19.0098 13.5221 20.7738C13.9421 19.5838 14.7541 18.7718 15.6781 18.7718Z",
			fill: "url(#paint4_linear_5_4677)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6059 36.4961C13.7879 36.5241 13.9559 36.4681 14.0819 36.3561C16.3639 34.3401 19.8919 33.2481 22.5379 33.2481H22.9999H23.4619C26.1079 33.2481 29.6359 34.3401 31.9179 36.3561C32.0439 36.4681 32.2259 36.5241 32.3939 36.4961C32.5759 36.4681 32.6739 36.2721 32.5759 36.1181C30.6299 32.9261 27.0179 30.9521 23.1119 30.9521H22.9999H22.8879C18.9679 30.9521 15.3699 32.9261 13.4239 36.1181C13.3119 36.2721 13.4099 36.4681 13.6059 36.4961Z",
			fill: "#643800"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6059 36.4958C13.7879 36.5238 13.9559 36.4678 14.0819 36.3558C16.3639 34.3398 19.8919 33.2478 22.5379 33.2478H22.9999H23.4619C26.1079 33.2478 29.6359 34.3398 31.9179 36.3558C32.0439 36.4678 32.2259 36.5238 32.3939 36.4958C32.5759 36.4678 32.6739 36.2718 32.5759 36.1178C32.5619 36.0898 32.5339 36.0618 32.5199 36.0198C32.3379 36.1178 32.1419 36.2158 31.9319 36.0058C29.7619 33.7098 26.5559 32.3378 23.1119 32.3378H22.9859H22.8599C19.4019 32.3378 16.1679 33.7238 13.9979 36.0618C13.8019 36.2718 13.6199 36.1738 13.4379 36.0618C13.4239 36.0898 13.4099 36.1038 13.3959 36.1318C13.3119 36.2718 13.4099 36.4678 13.6059 36.4958Z",
			fill: "url(#paint5_linear_5_4677)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8221 15.118C26.5841 14.25 27.3821 13.452 28.9921 13.018C30.3641 12.654 33.5701 12.598 36.3561 14.712C36.8741 15.104 36.3561 15.524 35.8941 15.314C34.3261 14.572 30.5461 14.096 27.9561 15.104C26.9201 15.51 26.8221 15.118 26.8221 15.118Z",
			fill: "url(#paint6_linear_5_4677)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3081 24.2041C31.4988 24.2041 32.4641 22.7437 32.4641 20.9421C32.4641 19.1406 31.4988 17.6801 30.3081 17.6801C29.1174 17.6801 28.1521 19.1406 28.1521 20.9421C28.1521 22.7437 29.1174 24.2041 30.3081 24.2041Z",
			fill: "url(#paint7_radial_5_4677)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3081 18.7718C31.2321 18.7718 32.0441 19.5838 32.4641 20.7738C32.4361 19.0098 31.4841 17.5958 30.3081 17.5958C29.1321 17.5958 28.1801 19.0098 28.1521 20.7738C28.5721 19.5838 29.3841 18.7718 30.3081 18.7718Z",
			fill: "url(#paint8_linear_5_4677)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_5_4677",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(18.5872 13.922) scale(27.0227)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE030" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFB92E"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_5_4677",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(18.5872 13.922) scale(21.26)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFEA5F" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFBC47",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_5_4677",
				x1: 13.8483,
				y1: 16.7481,
				x2: 14.8161,
				y2: 13.1362,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#7A4400"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_5_4677",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(15.0367 21.0248) rotate(73.8539) scale(3.16496 2.04768)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_5_4677",
				x1: 15.6812,
				y1: 17.5951,
				x2: 15.6812,
				y2: 20.776,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_5_4677",
				x1: 22.9945,
				y1: 31.1751,
				x2: 22.9945,
				y2: 34.3115,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_5_4677",
				x1: 32.1118,
				y1: 16.8349,
				x2: 31.144,
				y2: 13.223,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#7A4400"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint7_radial_5_4677",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(29.6637 21.0251) rotate(73.8539) scale(3.16496 2.04768)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_5_4677",
				x1: 30.3079,
				y1: 17.5951,
				x2: 30.3079,
				y2: 20.776,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			})
		] })
	]
});
export { SvgFrowning as ReactComponent };
